import data from './data'
import methods from './methods'
import mounted from './mounted'
import props from './props'

export default {
  data,
  methods,
  mounted,
  props,

  resourcePath: 'v1/patient/scheduling/schedules/'
}



// WEBPACK FOOTER //
// ./src/app/patient/dashboard/gadget/components/upcoming/components/event-details/resources/index.js